import { render, staticRenderFns } from "./CourseCatagory.vue?vue&type=template&id=8f75070a&scoped=true&"
import script from "./CourseCatagory.vue?vue&type=script&lang=js&"
export * from "./CourseCatagory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f75070a",
  null
  
)

export default component.exports